import { IEpticaRequestFrame } from '@agent/core/channel-digit/mail/eptica/models/eptica.request.interfaces';
import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IPromise } from 'angular';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { Logger, Option } from '@contact/upgrade';

import { IEpticaMailContent } from './models/eptica-extract';

@Component({
  selector: 'history-mail-panel-content',
  templateUrl: './history-mail-panel-content.component.html',
  styleUrls: ['./history-mail-panel-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HistoryMailPanelContentComponent implements OnInit, OnChanges {
  @Input() public currentEmail: IEpticaMailContent;
  @Input() private requestPromise: IPromise<IEpticaRequestFrame>;
  @Input() responseId: string;
  public sanitizedHTML: SafeHtml;

  constructor(
    public logger: Logger,
    private readonly sanitizer: DomSanitizer,
    @Inject(I18NEXT_SERVICE) public $i18next: ITranslationService
  ) {
    this.logger = this.logger.forSource('HistoryMailPanelContentComponent');
  }

  ngOnInit() {
    this.sanitizedHTML = this.sanitizer.bypassSecurityTrustHtml(this.currentEmail.evt.contentHtml);
  }

  ngOnChanges(changes: SimpleChanges) {
    const { ['currentEmail']: entries } = changes;
    if (!(entries && entries.currentValue && entries.previousValue !== entries.currentValue)) {
      return;
    }
    this.sanitizedHTML = this.sanitizer.bypassSecurityTrustHtml(this.currentEmail.evt.contentHtml);
  }

  isEmpty(value: string | null | undefined): boolean {
    return Option.of(value)
      .filter(v => v !== '')
      .isEmpty();
  }

  switchContentFormat(elemId: string) {
    // click on Eptica's switch linked to have the same result when printing
    this.currentEmail.isHtmlFormat = !this.currentEmail.isHtmlFormat;
    if (!!this.requestPromise) {
      this.requestPromise.then(request => {
        request.switchCommentFormat(elemId);
      });
    }
  }

  getFormattedContent(isHtml: boolean): string {
    const htmlI18n = () => this.$i18next.t('commons:basic.html');
    const textI18n = () => this.$i18next.t('commons:basic.text');
    return this.$i18next.t('agent:contact.workspace.mail.history.mail_format.format', {
      format: isHtml ? htmlI18n() : textI18n(),
    });
  }

  getTrustedHtml(contentHtml: string): SafeHtml {
    return contentHtml;
  }
}
